import { useAuth } from "../components/auth/AuthProvider";

export const useMe = () => useAuth();
